import { NavLinkProps } from 'react-router-dom';
import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton';
import { UndecoratedNavLink } from './undecoratedNavLink';

export type NavListItemButtonProps = ListItemButtonProps & {
  to: NavLinkProps['to'];
  navLinkProps?: Omit<NavLinkProps, 'to'>;
  disableHighlight?: boolean;
  activeSx?: ListItemButtonProps['sx'];
};

/**
 * Wrapper around `ListItemButton` that adds `NavLink` functionality
 */
export function NavListItemButton({
  navLinkProps,
  to,
  disableHighlight = false,
  sx,
  activeSx,
  ...props
}: NavListItemButtonProps) {
  return (
    <UndecoratedNavLink to={to} end {...navLinkProps}>
      {({ isActive }) => {
        const internalSx = {
          ...sx,
          ...(!disableHighlight && isActive ? activeSx : {}),
        };
        return <ListItemButton selected={disableHighlight ? false : isActive} sx={internalSx} {...props} />;
      }}
    </UndecoratedNavLink>
  );
}
